(function () {
  'use strict';

  /* Scroller for the blog-posts slider: mouse drag-to-scroll (the shared helper
     in eb-drag-scroll.js; touch uses native scrolling) and arrows that page one
     card at a time. CSS scroll-snap settles the row after release. `is-dragging`
     is added only once a real drag starts, so a plain click on a card link still
     fires.

     Two arrow pairs can exist (beside the heading / on the card's edges); CSS
     shows one per breakpoint, so bind and update every one. Arrows stay put and
     hide at the ends (matching eb-discount-list) and the whole nav hides when the
     row doesn't scroll at all. */
  class EbBlogScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eb-bp-track]');
      if (!this.track) return;
      // The header arrow pair lives OUTSIDE this element (up in the section head),
      // so look arrows up from the section root, not just the scroller. Scoped to
      // this section's root so multiple blog sections on a page don't cross-wire.
      var scope = this.closest('.eb-blog') || this;
      this.navs = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-bp-nav]'));
      this.prevBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-bp-prev]'));
      this.nextBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-bp-next]'));

      window.EbDragScroll.attach(this.track);
      this.initArrows();

      // The theme editor re-renders the section before layout settles, so
      // measure again once the real box lands (and on any later resize).
      if (window.ResizeObserver) {
        var self = this;
        this.ro = new ResizeObserver(function () {
          self.updateArrows();
        });
        this.ro.observe(this.track);
      }
    }

    disconnectedCallback() {
      if (this.ro) {
        this.ro.disconnect();
        this.ro = null;
      }
    }

    /* One card + gap per click; falls back to most of the viewport width. */
    step() {
      var cell = this.track.firstElementChild;
      if (!cell) return this.track.clientWidth * 0.85;
      var gap = parseFloat(getComputedStyle(this.track).columnGap);
      if (isNaN(gap)) gap = 0;
      return cell.getBoundingClientRect().width + gap;
    }

    initArrows() {
      var self = this;
      if (!this.prevBtns.length && !this.nextBtns.length) return;

      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function page(dir) {
        self.track.scrollBy({
          left: dir * self.step(),
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      this.prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          page(-1);
        });
      });
      this.nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          page(1);
        });
      });

      this.updateArrows();
      this.track.addEventListener('scroll', function () {
        self.updateArrows();
      });
      window.addEventListener('resize', function () {
        self.updateArrows();
      });
    }

    updateArrows() {
      if (!this.prevBtns || (!this.prevBtns.length && !this.nextBtns.length)) return;
      var track = this.track;
      // 1px slack absorbs sub-pixel rounding at the ends.
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var scrollable = maxScroll > 1;
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= maxScroll;

      this.navs.forEach(function (nav) {
        nav.hidden = !scrollable;
      });
      // Hidden, not just disabled — an arrow pointing nowhere shouldn't show at all
      // (same behaviour as the discount row). `disabled` is kept in sync because the
      // header pair keeps its slot in the layout, so it must stay unclickable there.
      this.prevBtns.forEach(function (btn) {
        btn.hidden = atStart;
        btn.disabled = atStart;
      });
      this.nextBtns.forEach(function (btn) {
        btn.hidden = atEnd;
        btn.disabled = atEnd;
      });
    }
  }

  if (!customElements.get('eb-blog-scroller')) {
    customElements.define('eb-blog-scroller', EbBlogScroller);
  }
})();
